<div class="invoices-dialog" [mmTestId]="'DOWNLOAD_DOCUMENTS_DIALOG.CONTAINER'">
  <mm-dialog-title>
    <ng-container *ngIf="data.type === docTypes?.INVOICE">
      {{ 'PAGES.ACCOUNT.ORDERS_HISTORY.INVOICES' | translate }}
    </ng-container>
    <ng-container *ngIf="data.type === docTypes?.RETURN_LABEL">
      {{ 'PAGES.ACCOUNT.ORDERS_HISTORY.RETURN_LABELS' | translate }}
    </ng-container>

    <ng-container *ngIf="data.type === docTypes?.CREDIT_NOTE">
      {{ 'PAGES.ACCOUNT.ORDERS_HISTORY.CREDIT_NOTES' | translate }}
    </ng-container>
  </mm-dialog-title>

  <mm-dialog-content>
    <div class="invoices-dialog-content">
      <div class="invoices-dialog-content__file-list">
        <div class="invoices-dialog-content__file-list-item" *ngFor="let item of files">
          <button class="invoices-dialog-content__file-list-item-btn"
                  (click)="downloadDocument(item)">
            <span *ngFor="let namePart of item?.nameArr; let i = index"
                  [ngClass]="{'invoices-dialog-content__filename-first': i === 0}">{{namePart}}</span>
          </button>
          <div class="invoices-dialog-content__file-list-item-date">
            {{(item?.createdAt || item?.date) | date: dateFormat}}
          </div>
        </div>
      </div>
    </div>
  </mm-dialog-content>
</div>
